// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bootstrap-style Modal */
.Br8XCaDzrLgRZ2QqH57Q {
  position: fixed;
  inset: 0;
  background: rgba(1, 10, 20, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.MnzFEdssBIw8zmCr9Qm_ {
  max-width: 500px;
  width: 90%;
  margin: 1.75rem auto;
}

.nEV5ALG6XPzaU9HRArwe {
  background: var(--surface-bg);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  border: 1px solid var(--border-color);
  position: relative;
}

.OfblOO99ebVD27t_B26F {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  background: var(--surface-bg-2);
  border-radius: 10px 10px 0 0;
}

.iEJr05gdwSNyxHJYIiK8 { margin: 0; font-size: 1.1rem; font-weight: 600; color: var(--text-color); }

.b2QobSykkgPBip7Xd5nw {
  background: rgba(233, 192, 112, 0.14);
  border: 1px solid var(--border-color);
  font-size: 1.3rem;
  color: var(--text-color);
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.b2QobSykkgPBip7Xd5nw:hover { background: rgba(233, 192, 112, 0.24); }

.zWMFnF8qFxP4rHGOKXIM { padding: 1.25rem; color: var(--text-color); font-size: 0.95rem; line-height: 1.5; }
.zWMFnF8qFxP4rHGOKXIM p { margin: 0 0 0.75rem; }
.zWMFnF8qFxP4rHGOKXIM p:last-child { margin-bottom: 0; }

.hjvDOBS7e0t_NDfUijN1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border-color);
  background: var(--surface-bg-2);
  border-radius: 0 0 10px 10px;
}

.eektWeXFGsj7KNAya55d, .SKcNGdghBFGGScKd0n7G, .pDoNiWVxeY6ZU2f6o8fZ, .Zlj8QbTCN1Q7j5R4uLKo {
  padding: 0.375rem 0.75rem;
  font-size: 0.95rem;
  line-height: 1.5;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  border: 1px solid transparent;
}

.eektWeXFGsj7KNAya55d { color: var(--text-color); background: transparent; border-color: var(--border-color); }
.eektWeXFGsj7KNAya55d:hover:not(:disabled) { background: var(--surface-bg-2); }
.SKcNGdghBFGGScKd0n7G { color: #fff8e7; background: var(--accent-color); border-color: var(--border-color); }
.SKcNGdghBFGGScKd0n7G:hover:not(:disabled) { opacity: .9; }
.pDoNiWVxeY6ZU2f6o8fZ { color: #fff0e9; background: #8b2f2f; border-color: #c98572; }
.pDoNiWVxeY6ZU2f6o8fZ:hover:not(:disabled) { background: #a73838; }
.Zlj8QbTCN1Q7j5R4uLKo { color: #fff8e7; background: #866322; border-color: #dfb666; }
.Zlj8QbTCN1Q7j5R4uLKo:hover:not(:disabled) { background: #a1782d; }
.eektWeXFGsj7KNAya55d:disabled, .SKcNGdghBFGGScKd0n7G:disabled, .pDoNiWVxeY6ZU2f6o8fZ:disabled, .Zlj8QbTCN1Q7j5R4uLKo:disabled { opacity: 0.6; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./components/ConfirmDialog.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,wBAAc,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;;AAExF;EACE,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,8BAAoB,qCAAqC,EAAE;;AAE3D,wBAAa,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/F,0BAAe,mBAAmB,EAAE;AACpC,qCAA0B,gBAAgB,EAAE;;AAE5C;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,wBAAgB,wBAAwB,EAAE,uBAAuB,EAAE,iCAAiC,EAAE;AACtG,6CAAqC,+BAA+B,EAAE;AACtE,wBAAc,cAAc,EAAE,+BAA+B,EAAE,iCAAiC,EAAE;AAClG,6CAAmC,WAAW,EAAE;AAChD,wBAAa,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACzE,6CAAkC,mBAAmB,EAAE;AACvD,wBAAc,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC1E,6CAAmC,mBAAmB,EAAE;AACxD,iIAA0F,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":["/* Bootstrap-style Modal */\r\n.modalBackdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(1, 10, 20, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1050;\r\n}\r\n\r\n.modalDialog {\r\n  max-width: 500px;\r\n  width: 90%;\r\n  margin: 1.75rem auto;\r\n}\r\n\r\n.modalContent {\r\n  background: var(--surface-bg);\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\r\n  border: 1px solid var(--border-color);\r\n  position: relative;\r\n}\r\n\r\n.modalHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1rem 1.25rem;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background: var(--surface-bg-2);\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.modalTitle { margin: 0; font-size: 1.1rem; font-weight: 600; color: var(--text-color); }\r\n\r\n.modalClose {\r\n  background: rgba(233, 192, 112, 0.14);\r\n  border: 1px solid var(--border-color);\r\n  font-size: 1.3rem;\r\n  color: var(--text-color);\r\n  cursor: pointer;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 6px;\r\n}\r\n\r\n.modalClose:hover { background: rgba(233, 192, 112, 0.24); }\r\n\r\n.modalBody { padding: 1.25rem; color: var(--text-color); font-size: 0.95rem; line-height: 1.5; }\r\n.modalBody p { margin: 0 0 0.75rem; }\r\n.modalBody p:last-child { margin-bottom: 0; }\r\n\r\n.modalFooter {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n  padding: 1rem 1.25rem;\r\n  border-top: 1px solid var(--border-color);\r\n  background: var(--surface-bg-2);\r\n  border-radius: 0 0 10px 10px;\r\n}\r\n\r\n.btnSecondary, .btnPrimary, .btnDanger, .btnWarning {\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.btnSecondary { color: var(--text-color); background: transparent; border-color: var(--border-color); }\r\n.btnSecondary:hover:not(:disabled) { background: var(--surface-bg-2); }\r\n.btnPrimary { color: #fff8e7; background: var(--accent-color); border-color: var(--border-color); }\r\n.btnPrimary:hover:not(:disabled) { opacity: .9; }\r\n.btnDanger { color: #fff0e9; background: #8b2f2f; border-color: #c98572; }\r\n.btnDanger:hover:not(:disabled) { background: #a73838; }\r\n.btnWarning { color: #fff8e7; background: #866322; border-color: #dfb666; }\r\n.btnWarning:hover:not(:disabled) { background: #a1782d; }\r\n.btnSecondary:disabled, .btnPrimary:disabled, .btnDanger:disabled, .btnWarning:disabled { opacity: 0.6; cursor: not-allowed; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `Br8XCaDzrLgRZ2QqH57Q`,
	"modalDialog": `MnzFEdssBIw8zmCr9Qm_`,
	"modalContent": `nEV5ALG6XPzaU9HRArwe`,
	"modalHeader": `OfblOO99ebVD27t_B26F`,
	"modalTitle": `iEJr05gdwSNyxHJYIiK8`,
	"modalClose": `b2QobSykkgPBip7Xd5nw`,
	"modalBody": `zWMFnF8qFxP4rHGOKXIM`,
	"modalFooter": `hjvDOBS7e0t_NDfUijN1`,
	"btnSecondary": `eektWeXFGsj7KNAya55d`,
	"btnPrimary": `SKcNGdghBFGGScKd0n7G`,
	"btnDanger": `pDoNiWVxeY6ZU2f6o8fZ`,
	"btnWarning": `Zlj8QbTCN1Q7j5R4uLKo`
};
export default ___CSS_LOADER_EXPORT___;
